import React from 'react';
import { useSwiper } from '../hooks/useSwiper';
import TestimonialCard from './TestimonialCard';
import { useTranslation } from 'react-i18next';

const TestimonialSecOne = ({ className }) => {
  const thumbsSwiperRef = useSwiper('#testiThumbSlider1');
  const mainSwiperRef = useSwiper('#testiSlider1', '#testiThumbSlider1');
  
  const { t } = useTranslation();
  const testimonialThumbs = t('sections.testimonialSecOne.thumbs', { returnObjects: true, defaultValue: [
    { img: 'assets/img/testimonial/1-1.png', alt: 'Testimonial 1' },
    { img: 'assets/img/testimonial/1-2.png', alt: 'Testimonial 2' },
    { img: 'assets/img/testimonial/1-3.png', alt: 'Testimonial 3' },
    { img: 'assets/img/testimonial/1-1.png', alt: 'Testimonial 4' },
    { img: 'assets/img/testimonial/1-2.png', alt: 'Testimonial 5' },
    { img: 'assets/img/testimonial/1-3.png', alt: 'Testimonial 6' }
  ] });

  return (
    <section className={className} data-bg-src="assets/img/bg/testi_bg_shape1.png">
      <div className="testi-quote-icon shape-mockup" data-top="-12%" data-left="3%">
        <img src="assets/img/icon/quote-icon1.svg" alt="quote icon" />
      </div>
      <div className="testi-quote-icon2 shape-mockup" data-top="-8%" data-right="3%">
        <img src="assets/img/icon/quote-icon2.svg" alt="quote icon" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="title-area text-center">
              <span className="sub-title" data-cue="slideInUp">{t('sections.testimonialSecOne.sub_title','Our Testimonial')}</span>
              <h2 className="sec-title" data-cue="slideInUp">{t('sections.testimonialSecOne.title','Hear from Our Satisfied Clients')}</h2>
            </div>
          </div>
        </div>
        <div className="slider-area testi-thumb-slider1">
          <div 
            ref={thumbsSwiperRef}
            className="swiper ot-react-slider" 
            id="testiThumbSlider1" 
            data-slider-options='{"centeredSlides": true,"autoplay":false,"freeMode":true,"slideToClickedSlide":true,"watchSlidesProgress":true,"loop":true,"breakpoints":{"0":{"slidesPerView":1},"600":{"slidesPerView":"3"}},"thumbs":{"swiper":"#testiSlider1"}}'
          >
            <div className="swiper-wrapper">
              {testimonialThumbs.map((thumb, index) => (
                <div className="swiper-slide" key={index}>
                  <div className="testi-card-thumb">
                    <img src={thumb.img} alt={t(`sections.testimonialSecOne.thumbs.${index}.alt`, thumb.alt)} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="slider-area testi-slider1">
          <div 
            ref={mainSwiperRef}
            className="swiper ot-react-slider" 
            id="testiSlider1" 
            data-slider-options='{"autoHeight": true,"autoplay":false,"effect":"fade","loop":false}'
          >
            <div className="swiper-wrapper">
              <TestimonialCard className="swiper-slide" limit={6} />
            </div>
          </div>
          <button data-slider-prev="#testiThumbSlider1" className="slider-arrow slider-prev">
            <i className="far fa-angle-left" />
          </button>
          <button data-slider-next="#testiThumbSlider1" className="slider-arrow slider-next">
            <i className="far fa-angle-right" />
          </button>
        </div>
      </div>
    </section>
    
  );
};

export default TestimonialSecOne;